<h1 class="modal__header">Your Premium Details</h1>

<div class="premium-breakdown-table">
  <div class="premium-breakdown-table__row">
    <div class="premium-breakdown-table__heading">Base premium</div>
    <div class="premium-breakdown-table__data">{{ base }}</div>
  </div>

  <div *ngIf="isART" class="premium-breakdown-table__row">
    <div *ngIf="!increaseDate; else issued" class="premium-breakdown-table__disclaimer">
      *Increases to ${{ premiumIncrease }} after one year
    </div>
    <ng-template #issued>
      <div class="premium-breakdown-table__disclaimer">
        *Increases to ${{ premiumIncrease }} on {{ increaseDate | date: 'short' }}
      </div>
    </ng-template>
  </div>

  <div *ngIf="waiver" class="premium-breakdown-table__row">
    <div class="premium-breakdown-table__heading">Waiver of premium</div>
    <div class="premium-breakdown-table__data">{{ waiver }}</div>
  </div>

  <div *ngIf="isART && waiver" class="premium-breakdown-table__row">
    <div *ngIf="waiverIncreased; else noIncrease">
      <div *ngIf="!increaseDate; else issued" class="premium-breakdown-table__disclaimer">
        *Increases to ${{ waiverIncrease }} after one year
      </div>
      <ng-template #issued>
        <div class="premium-breakdown-table__disclaimer">
          *Increases to ${{ waiverIncrease }} on {{ increaseDate | date: 'short' }}
        </div>
      </ng-template>
    </div>
    <ng-template #noIncrease>
      <div class="premium-breakdown-table__disclaimer">*Stays the same after one year</div>
    </ng-template>
  </div>

  <div *ngIf="basePremiumGIR" class="premium-breakdown-table__row">
    <div class="premium-breakdown-table__heading">Guaranteed Insurability Rider</div>
    <div class="premium-breakdown-table__data">{{ basePremiumGIR }}</div>
  </div>

  <div *ngIf="basePremiumRTR" class="premium-breakdown-table__row">
    <div class="premium-breakdown-table__heading">Renewable Term Rider</div>
    <div class="premium-breakdown-table__data">{{ basePremiumRTR }}</div>
  </div>

  <div *ngIf="basePremiumALIR" class="premium-breakdown-table__row">
    <div class="premium-breakdown-table__heading">Additional Life Insurance Rider</div>
    <div class="premium-breakdown-table__data">{{ basePremiumALIR }}</div>
  </div>

  <div *ngIf="basePremiumCIR" class="premium-breakdown-table__row">
    <div class="premium-breakdown-table__heading">Chronic Illness Rider</div>
    <div class="premium-breakdown-table__data">{{ basePremiumCIR }}</div>
  </div>

  <ng-container *ngIf="flatExtras.length">
    <div class="premium-breakdown-table__row">
      <div class="premium-breakdown-table__heading">Flat extras</div>
    </div>

    <ng-container *ngFor="let flatExtra of flatExtras">
      <div class="premium-breakdown-table__row premium-breakdown-table__row-flat-extra">
        <div class="premium-breakdown-table__heading premium-breakdown-table__heading-flat-extra">
          {{ flatExtra.displayText }}
          <tooltip [helpText]="flatExtra.toolTip"></tooltip>
        </div>
        <div class="premium-breakdown-table__data">{{ flatExtra.amount }}</div>
      </div>
    </ng-container>
  </ng-container>

  <div class="premium-breakdown-table__row premium-breakdown-table__row-total">
    <div class="premium-breakdown-table__heading premium-breakdown-table__heading-total">Your total premium</div>
    <div class="premium-breakdown-table__data premium-breakdown-table__data-total">
      {{ total }}
      <p class="premium-breakdown-table__data premium-breakdown-table__data-total-month">{{ timeFrequency }}</p>
    </div>
  </div>
</div>

<div class="modal__actions">
  <button class="button button--blue button--primary modal__button" (click)="closeModal()">Exit</button>
</div>
